import { render, staticRenderFns } from "./grouponRule.vue?vue&type=template&id=f34906b8"
import script from "./grouponRule.vue?vue&type=script&lang=js"
export * from "./grouponRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f34906b8')) {
      api.createRecord('f34906b8', component.options)
    } else {
      api.reload('f34906b8', component.options)
    }
    module.hot.accept("./grouponRule.vue?vue&type=template&id=f34906b8", function () {
      api.rerender('f34906b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/promotion/grouponRule.vue"
export default component.exports